import script from "./DonateView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DonateView.vue?vue&type=script&setup=true&lang=ts"

import "./DonateView.vue?vue&type=style&index=0&id=2f956870&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f956870"]])

export default __exports__